import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../../app/_services/app.service';
import { DecryptPipe } from '../../../../app/auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../services/commen/commen.services';
import { NetworkService } from '../../services/network/network.service';
import { VehicleService } from '../../services/vehicle/vehicle.service';
import { Helpers } from '../../../../app/helpers';
import { DriverService } from '../../services/driver/driver.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { Http } from '@angular/http';

@Component({
  selector: 'app-create-new-customer',
  templateUrl: './create-new-customer.component.html',
  styleUrls: ['./create-new-customer.component.scss']
})
// Added by priya - 14/04/2026 - cn(PRIYA-APR26-006)
export class CreateNewCustomerComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  isFormSubmit: boolean = false;
  isAddFormSubmit: boolean = false;
  isTaxFormSubmit: boolean = false;
  isSearch: boolean = false;
  isMobileView: any;
  TenantId: any;
  CompanyId: any;
  userId: any;
  IsShowListForSalesPersonBroker: boolean = false;
  data: any = {};
  Addressdata: any = {};
  Taxdata: any = {};
  OtherDetails: any = {};
  DefaultNetworkAccountsType: any = [];
  networkId: any;
  pTableIndex: any = 0;
  tabName: any = '';
  ApplicableTDS: any;
  registrationObj: any = {};
  listOfFile: any[];
  registerarray: any[] = [];
  isdatedisable: boolean;
  listOfField: any = []
  ExportsType: any = [];

  companyFulName: any = {
    lable: 'Company Full Name',
    formControlName: 'FullName',
    dataField: 'FullName',
    isRequired: true,
    placeholder: 'Enter Company Full Name',
  };
  companyShortCode: any = {
    lable: 'Company Short Name',
    formControlName: 'ShortName',
    dataField: 'ShortName',
    isRequired: true,
    placeholder: 'Enter Company Short Name',
  };
  NetworkType: any = {
    lable: "Network Type",
    formControlName: 'TransportIds',
    dataField: 'TransportIds',
    isRequired: true,
    isValueBind: true,
    placeholder: "Select Network Type",
    isMultipleSelect: true
  };
  NetworkSubType: any = {
    lable: "Network Sub Type",
    dataField: 'TransporterType',
    formControlName: 'TransporterType',
    isRequired: true,
    placeholder: "Select Network Sub Type",
    isValueBind: true,
  };
  deliveryPartner: any = {
    lable: "Default Delivery Partner",
    formControlName: 'DeliveryPartner',
    dataField: 'DeliveryPartner',
    //    isRequired: true,
    isValueBind: true,
    placeholder: "Enter delivery partner name",
  };
  accountType: any = {
    lable: "Chart of Account Group (Ledger will be created under this account group)",
    dataField: 'AccountTypeId',
    formControlName: 'AccountTypeId',
    isRequired: true,
    isSearchByApi: true,
    placeholder: "Select Chart of Account Group",
    isValueBind: true,
    isSearchStatus: true
  };
  invoiceDueDays: any = {
    lable: "Invoice Due Days in nos",
    dataField: 'InvoiceDue',
    formControlName: 'InvoiceDue',
    isRequired: true,
    // isFullObject: true,
    isValueBind: true,
    placeholder: "Enter invoice due days",
    type: 'number',
  };
  SalesPerson: any = {
    lable: 'Sales Person (Mandatory if Customer)',
    placeholder: "Enter Sales Person",
    dataField: 'SalesPerson',
    formControlName: 'SalesPerson',
    isRequired: false,
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  Broker: any = {
    lable: 'Broker',
    placeholder: "Select Broker",
    dataField: 'Broker',
    formControlName: 'Broker',
    isRequired: false,
    isSearchByApi: true,
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  ColorPalette: any = {
    lable: "Color Palette",
    formControlName: 'ColorPalette',
    dataField: 'ColorPalette',
    type: "color",
    placeholder: "Enter Color Palette",
  };
  unitNo: any = {
    lable: "Unit No",
    dataField: 'UnitNo',
    formControlName: 'UnitNo',
    placeholder: "Enter Unit No",
  };
  floor: any = {
    lable: "Floor",
    dataField: 'FloorNo',
    formControlName: 'FloorNo',
    placeholder: "Enter Floor",
  };
  flat: any = {
    lable: "Flat",
    dataField: 'FlatNo',
    formControlName: 'FlatNo',
    placeholder: "Enter Flat",
  };
  landmark: any = {
    lable: "Landmark",
    dataField: 'LandMark',
    formControlName: 'LandMark',
    placeholder: "Enter Landmark",
  };
  address: any = {
    lable: "Address",
    dataField: 'Address',
    formControlName: 'Address',
    placeholder: "Enter Address",
  };
  postalCode: any = {
    lable: "Pincode",
    dataField: 'PostalCode',
    formControlName: 'PostalCode',
    placeholder: "Select Pincode",
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  country: any = {
    lable: "Country",
    dataField: 'Country',
    formControlName: 'Country',
    placeholder: "Select Country",
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  state: any = {
    lable: "State",
    dataField: 'State',
    formControlName: 'State',
    placeholder: "Select State",
    isReadOnly: false,
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  city: any = {
    lable: "City",
    dataField: 'City',
    formControlName: 'City',
    isReadOnly: false,
    placeholder: "City",
    typeOfField: 'dropdown',
    isValueBind: true,
    isSearchStatus: true
  };
  ContactPersonOffical: any = {
    lable: "Contact Person Name",
    dataFieldTemp: 'ContactPersonOffical',
    formControlName: 'ContactPersonOffical',
    dataField: 'ContactPerson',
    isValueBind: true,
    placeholder: "Enter Contact Person Name",
  };
  phoneOffical: any = {
    lable: "Mobile No",
    dataFieldTemp: 'phoneOffical',
    formControlName: 'phoneOffical',
    dataField: 'Phone',
    type: 'number',
    placeholder: "Enter Mobile No",
  };
  emailOffical: any = {
    lable: "Email",
    dataFieldTemp: 'emailOffical',
    formControlName: 'emailOffical',
    dataField: 'Email',
    placeholder: "Enter Email",
  };
  TaxExemptionReason: any = {
    lable: 'Tax Exemption Reason',
    formControlName: 'Label',
    dataField: 'TaxExemptionId',
    placeholder: 'Select tax exemption reason',
    isValueBind: true,
    isReadOnly: true,
    isRequired: false
  };
  ManageTdsList: any = {
    lable: 'Applicable TDS',
    formControlName: 'Label',
    dataField: 'ManageTdsId',
    placeholder: 'Applicable TDS',
    isValueBind: true,
    isReadOnly: true,
    isRequired: false
  };
  LUTBondNumber: any = {
    lable: 'LUT Bond Number',
    formControlName: 'LUTBondNumber',
    dataField: 'LUTBondNumber',
    type: "text",
    placeholder: 'LUT Bond Number',
    isRequired: false
  };
  LUTBondStartDate: any = {
    lable: 'LUT Bond Start Date',
    dataField: 'LUTBondStartDate',
    formControlName: 'LUTBondStartDate',
    placeholder: 'Select LUT Bond Start Date',
    isRequired: false
  };
  LUTBondEndDate: any = {
    lable: 'LUT Bond End Date',
    dataField: 'LUTBondEndDate',
    formControlName: 'LUTBondEndDate',
    placeholder: 'Select LUT Bond End Date',
    isRequired: false
  };
  ExportType: any = {
    lable: 'Export Type',
    formControlName: 'Label',
    dataField: 'ExportType',
    placeholder: 'Select Export Type',
    isValueBind: true
  };
  ReverseChangeMechnaism: any = {
    dataField: 'IsReverseChargeApplicable',
    formControlName: 'IsReverseChargeApplicable',
  };
  IsTDSdeductionrequired: any = {
    dataField: 'IsTDSdeductionrequired',
    formControlName: 'IsTDSdeductionrequired',
  };
  IseWayBillmandatoryrequirement: any = {
    dataField: 'eWayBill',
    formControlName: 'eWayBill',
  };
  IsPermitmandatoryrequirement: any = {
    dataField: 'PermitNumber',
    formControlName: 'PermitNumber',
  };

  constructor(
    private _appService: appService,
    private networkService: NetworkService,
    private vehicleService: VehicleService,
    private cookieService: CookieService,
    private commonService: CommonService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private driverService: DriverService,
    private translate: TranslateService,
    private anghttp: Http,
  ) { }

  ngOnInit() {
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    this.CompanyId = JSON.parse(localStorage.getItem("ChnageCompnayId")).Id;
    this.TenantId = JSON.parse(localStorage.getItem("ChnageCompnayId")).TenantId;
    this.switchTab('Company Details');
    this.tabName = 'Company Details';
    this.GetShowListForSalesPersonBroker();
    this.GetDeliverPartnerList();
    this.GetNetworkSubTypeList();
    this.GetTransportServiceType();
    // this.getAccountType('%%');
    this.GetDefaultNetworkAccountsType();
    this.GetTaxExemptionReason();
    this.GetManageTds();
    this.GetExportType();
  }

  switchTab(tabName: any) {
    this.tabName = tabName;
    if (tabName == 'Address') {
      if (this.Addressdata && !this.Addressdata.Country) {
        this.getCountryDetailsV2("India", 'Country', null, 'country')
      }
    }
    if (tabName == 'Tax') {
      if (this.Taxdata && !this.Taxdata.TaxPreference) {
        this.Taxdata.TaxPreference = 'TaxExempt';
        this.TaxExemptionReason.isReadOnly = false;
        this.TaxExemptionReason.isRequired = true;
      }
      if (this.Taxdata && this.Taxdata.TaxPreference == 'Taxable') {
        this.TaxExemptionReason.isReadOnly = true;
        this.TaxExemptionReason.isRequired = false;
        this.LUTBondNumber.isRequired = false;
        this.LUTBondStartDate.isRequired = false;
        this.LUTBondEndDate.isRequired = false;
      } else if (this.Taxdata && this.Taxdata.TaxPreference == 'TaxExempt') {
        this.TaxExemptionReason.isReadOnly = false;
        this.TaxExemptionReason.isRequired = true;
      } else {
        this.TaxExemptionReason.isReadOnly = false;
        this.TaxExemptionReason.isRequired = false;
        this.LUTBondNumber.isRequired = false;
        this.LUTBondStartDate.isRequired = false;
        this.LUTBondEndDate.isRequired = false;
      }

      if (this.Taxdata && this.Taxdata.IsTDSdeductionrequired == true) {
        this.ManageTdsList.isReadOnly = false;
        this.ManageTdsList.isRequired = true;
      } else {
        this.ManageTdsList.isReadOnly = true;
        this.ManageTdsList.isRequired = false;
      }

      if (this.Taxdata && this.Taxdata.IsTDSdeductionrequired == true) {
        this.ManageTdsList.dropdownList = this.ManageTdsList.dropdownList.filter(x => x.name !== 'Not Applicable');
      }
    }
    if (tabName == 'Registration') {
      this.GetRegister();
      this.GetTaxPreference();
    }
  }

  getChangedValue(value: any, data: any) {
    if (value === undefined) {
      value = null;
      this.data[data] = value;
    } else {
      if (data === 'FullName') {
        //added by BURHAN - 14-August-2026
        if (typeof value === 'string' && value.trim().length === 0) {
          this.data[data] = '';
          return;
        }
        //end by BURHAN
        if (value.length > 255) {
          this.toastr.warning('Full Name cannot exceed 255 characters');
          return;
        }
        this.data[data] = value;
      } else if (data === 'ShortName') {
        if (typeof value === 'string' && value.trim().length === 0) {
          this.data[data] = '';
          return;
        }
        this.data[data] = value;
      } else if (data === 'TransportIds') {
        this.data[data] = value;
        this.checkNetworkTypeCondition(value);
      } else if (data === 'TransporterType') {
        this.data[data] = value;
      } else if (data === 'DeliveryPartner') {
        this.data[data] = value.value;
      } else if (data === 'AccountTypeId') {
        this.data[data] = value.value;
      } else if (data === 'InvoiceDue') {
        this.data[data] = value;
      } else if (data === 'SalesPerson') {
        this.data[data] = value.value;
      } else if (data === 'Broker') {
        this.data[data] = value.value;
      } else if (data === 'ColorPalette') {
        this.data[data] = value;
      }
    }
  }

  getAddChangedValue(value: any, dataField: any) {
    if (value === undefined) {
      value = null;
      this.Addressdata[dataField] = value;
    } else {
      if (dataField === 'Country' || dataField === 'City' ||
        dataField === 'PostalCode' || dataField === 'State') {
        // this.data[dataField] = value.value;
        this.Addressdata[dataField] = (value && value.value) ? value.value : value;
        if (dataField === 'PostalCode') {
          const addressDetails = value
          // this.Addressdata.City = addressDetails.CityName || null;
          this.Addressdata.Country = addressDetails.CountryName || null;
          // this.Addressdata.State = addressDetails.StateName || null;

          this.setAddDropdownData(this.city, addressDetails.CityName, addressDetails.CityName);
          this.setAddDropdownData(this.state, addressDetails.StateName, addressDetails.StateName);
        }
      } else {
        this.Addressdata[dataField] = value;
      }
    }
    this.readonlyStateChange();
  }

  // Added by priya - 16/04/2026 - cn(PRIYA-APR26-008)
  getTaxChangedValue(value: any, dataField: any) {
    if (this.Taxdata == null)
      this.Taxdata = {};
    this.Taxdata[dataField] = value;
    if (dataField == 'taxPreference') {
      if (value == 'Taxable') {
        this.TaxExemptionReason.isReadOnly = true;
        this.TaxExemptionReason.isRequired = false;
        this.LUTBondNumber.isRequired = false;
        this.LUTBondStartDate.isRequired = false;
        this.LUTBondEndDate.isRequired = false;
      } else if (value == 'TaxExempt') {
        this.TaxExemptionReason.isReadOnly = false;
        this.TaxExemptionReason.isRequired = true;
      } else {
        this.TaxExemptionReason.isReadOnly = false;
        this.TaxExemptionReason.isRequired = false;
        this.LUTBondNumber.isRequired = false;
        this.LUTBondStartDate.isRequired = false;
        this.LUTBondEndDate.isRequired = false;
      }
    } else if (dataField == 'IsTDSdeductionrequired') {
      if (value == true) {
        this.ManageTdsList.isReadOnly = false;
        this.ManageTdsList.isRequired = true;
        this.ManageTdsList.dropdownList = this.ManageTdsList.dropdownList.filter((x: any) => x.name !== 'Not Applicable');
      } else {
        this.ManageTdsList.isReadOnly = true;
        this.ManageTdsList.isRequired = false;
      }
    } else if (dataField == 'TaxExemptionId') {
      var sezdata = this.TaxExemptionReason.dropdownList.filter((x: any) => x.value === value);
      this.Taxdata.TaxExemptionName = sezdata.length > 0 ? sezdata[0].name : null;

      if (this.Taxdata && this.Taxdata.TaxExemptionName == 'SEZ Customer') {
        this.LUTBondNumber.isRequired = true;
        this.LUTBondStartDate.isRequired = true;
        this.LUTBondEndDate.isRequired = true;
      } else {
        this.LUTBondNumber.isRequired = false;
        this.LUTBondStartDate.isRequired = false;
        this.LUTBondEndDate.isRequired = false;
      }
    }
  }

  getRegChangedValue(value: any, dataFeild: any, item: any) {
    item[dataFeild] = value;
    if (dataFeild == "IsForLifeTime") {
      this.isdatedisable = value;
    }
    const filteredData = this.registerarray.map(item => {
      const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
      return filteredItem;
    });
    console.log("getchanged", value, dataFeild);
    console.log("getchanged", filteredData);
  }

  readonlyStateChange() {
    if (this.Addressdata) {
      this.state.isReadOnly = this.Addressdata[this.country.dataField] ? false : true;
      this.city.isReadOnly = this.Addressdata[this.state.dataField] ? false : true;
    }
  }

  //comment by BURHAN - 14-August-2026
  // ValidateCompanyData() {
  //   const objectCompany = this.data && this.data;
  //   if (objectCompany.InvoiceDue == null) {
  //     objectCompany.InvoiceDue = 0;
  //   }
  //   if (
  //     objectCompany.FullName &&
  //     objectCompany.ShortName &&
  //     objectCompany.TransportIds &&
  //     objectCompany.TransporterType &&
  //     objectCompany.AccountTypeId &&
  //     objectCompany.InvoiceDue !== null &&
  //     objectCompany.InvoiceDue !== undefined &&
  //     (!this.data.SalesPerson.isRequired || objectCompany.SalesPerson)
  //   ) {
  //     return true;
  //   } else {
  //     var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
  //     this.toastr.error(RequiredError, "error");
  //     return false;
  //   }
  // }

  ValidateCompanyData() {
    const objectCompany = this.data || {};
    if (objectCompany.InvoiceDue == null) objectCompany.InvoiceDue = 0;

    const isEmpty = (val: any) => {
      if (!val) return true;
      if (Array.isArray(val)) return val.length === 0;
      return String(val).trim() === '';
    };

    if (isEmpty(objectCompany.FullName)) this.data.FullName = '';
    if (isEmpty(objectCompany.ShortName)) this.data.ShortName = '';

    // const objectCompany = this.data && this.data;  // commented by yash 
    const objectAddress = this.Addressdata && this.Addressdata;  // added by yash 14-08-2026
    if (objectCompany.InvoiceDue == null) {
      objectCompany.InvoiceDue = 0;
    }
    // added by yash 14-08-2026
    if (this.tabName == 'Address') {
      if (!objectAddress.phoneOffical || objectAddress.phoneOffical.toString().trim() === '') {
        this.toastr.warning("Please Enter Mobile No", "Warning");
        return false;
      }
    }
    // end by yash 14-08-2026
    if (
      !isEmpty(objectCompany.FullName) &&
      !isEmpty(objectCompany.ShortName) &&
      !isEmpty(objectCompany.TransportIds) &&
      !isEmpty(objectCompany.TransporterType) &&
      !isEmpty(objectCompany.AccountTypeId)
    ) {

      this.data.FullName = String(this.data.FullName).trim();
      this.data.ShortName = String(this.data.ShortName).trim();
      return true;
    } else {
      this.toastr.warning(this.translate.instant("DriverDetailsById.RequiredError"), "Warning");
      return false;
    }
  }
  //end by BURHAN

  ValidateTaxData() {
    var flag: any = true;
    const objectCompany = this.Taxdata;
    if (objectCompany.TaxPreference == 'TaxExempt') {
      if (!objectCompany.TaxExemptionId) {
        flag = false;
      }
      if (objectCompany.TaxExemptionName == 'SEZ Customer') {
        if (!objectCompany.LUTBondNumber ||
          !objectCompany.LUTBondStartDate ||
          !objectCompany.LUTBondEndDate) {
          flag = false;
        }
      }
    }
    if (objectCompany.IsTDSdeductionrequired == true) {
      if (!objectCompany.ManageTdsId) {
        flag = false;
      }
    }
    if (flag == false) {
      var RequiredError = this.translate.instant("DriverDetailsById.RequiredError");
      this.toastr.error(RequiredError, "error");
      flag = false;
    }
    return flag;
  }

  OnSave() {
    if (this.tabName == 'Company Details') {
      // ADDED BY BURHAN - 14-Aug-2026
      let hasOnlySpaceError = false;

      if (this.data.FullName && typeof this.data.FullName === 'string' && this.data.FullName.trim() === '') {
        this.data.FullName = '';
        hasOnlySpaceError = true;
      }
      if (this.data.ShortName && typeof this.data.ShortName === 'string' && this.data.ShortName.trim() === '') {
        this.data.ShortName = '';
        hasOnlySpaceError = true;
      }

      if (hasOnlySpaceError) {
        this.toastr.warning("Only spaces are not allowed", "Warning");
      }
      // END BY BURHAN
      this.isFormSubmit = true;
      if (this.ValidateCompanyData()) {
        this.SaveCompany();
      }
    }
    if (this.tabName == 'Address') {
      if (this.ValidateCompanyData()) {
        this.SaveCompanyAddress();
      }
    }
    if (this.tabName == 'Tax') {
      this.isTaxFormSubmit = true;
      if (this.ValidateTaxData()) {
        this.SaveCompanyTax();
      }
    }
    if(this.tabName == 'Registration'){
      this.saveRegistrationData();
    }
  }

  SaveCompany() {
    Helpers.setLoading(true);
    this.data.CreditLimit = 0;
    this.data.Website = null;
    this.data.AboutCompany = null;
    this.data.IsNetworkCompany = true;
    this.data.TenantId = this.TenantId;
    this.data.ConversionFactor = null;
    this.data.IsInsure = true;
    this.data.IsFov_Rov = 0;
    this.data.isFragile = false;
    this.data.IsConversionFactorAuto = false;
    this.data.IsIndentAsLR = false;
    this.data.UserId = this.userId;
    this._appService.Post("Company", "SaveCompany", this.data).subscribe((response) => {
      Helpers.setLoading(false);
      this.toastr.success("Data saved", "Success");
      if (!this.data.Id) {
        this.data.Id = response;
        this.networkId = response;
        this.data.CompanyStatus = 'UnAuthorized';
        setTimeout(() => {
          this.authorizeTransaction(this.networkId);
        }, 200);
        this.pTableIndex = 1;
        this.switchTab('Address');
      } else {
        this.onclose();
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  // Added by priya - 16/04/2026 - cn(PRIYA-APR26-006)
  SaveCompanyAddress() {
    this.isAddFormSubmit = true;
    this.Addressdata.FloorNo = this.Addressdata.FloorNo;
    this.Addressdata.FlatNo = this.Addressdata.FlatNo;
    this.Addressdata.LandMark = this.Addressdata.LandMark;
    this.Addressdata.ContactPerson = this.Addressdata.ContactPersonOffical;
    this.Addressdata.Phone = this.Addressdata.phoneOffical;
    this.Addressdata.Email = this.Addressdata.emailOffical;
    this.Addressdata.CompanyId = this.networkId;
    // const payload = {
    //   ...this.Addressdata,
    //   City: this.Addressdata.City.value || this.Addressdata.City,
    //   State: this.Addressdata.State.value || this.Addressdata.State,
    //   Country: this.Addressdata.Country.value || this.Addressdata.Country,
    // }
    if (this.Addressdata.Address && this.Addressdata.Address.trim().length === 0){
      this.toastr.warning("Address cannot contain only blank spaces.");
      return;
    }
    const obj = {
      OfficialAddress: { ...this.Addressdata, IsNetworkCompany: true },
      BillingAddress: {
        CompanyId: this.networkId,
        FloorNo: '',
        UnitNo: '',
        FlatNo: '',
        LandMark: '',
        Address: '',
        PostalCode: '',
        State: '',
        City: '',
        ContactPerson: '',
        Phone: '',
        Email: '',
        IsNetworkCompany: true
      }
    }

    Helpers.setLoading(true);
    this._appService.Post("Company", "SaveCompanyAddress", obj).subscribe((response) => {
      Helpers.setLoading(false);
      this.toastr.success("Data saved", "Success");
      this.pTableIndex = 2;
      this.switchTab('Tax');
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  SaveCompanyTax() {
    this.Taxdata.TDSPreference = this.Taxdata.IsTDSdeductionrequired == true ? 'Deducted' : 'NotDeducted';
    this.Taxdata.eWayBill = this.Taxdata.eWayBill == true ? 'Mandatory' : 'NotMandatory';
    this.Taxdata.PermitNumber = this.Taxdata.PermitNumber == true ? 'Mandatory' : 'NotMandatory';
    this.Taxdata.CompanyId = this.networkId;
    Helpers.setLoading(true);
    this._appService.Post("Company", "OtherDetails", this.Taxdata).subscribe((response) => {
      Helpers.setLoading(false);
      this.toastr.success("Data saved", "Success");
      this.pTableIndex = 3;
      this.switchTab('Registration');
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
        Helpers.setLoading(false);
      }
    );
  }

  saveRegistrationData() {
    let taxPreference = '';
    if (this.Taxdata && this.Taxdata.TaxPreference) {
      taxPreference = this.Taxdata.TaxPreference;
    }
    const gst1Item = this.registerarray.find(
      item => item.Label === 'GST1 (15 digit)'
    );
    if (gst1Item && taxPreference === 'Taxable' && gst1Item.Number) {
      // if (!gst1Item.Number || gst1Item.Number.trim() === '') {
      //   this.toastr.error("GST1 (15 digit) number is required!", "Error");
      //   return false;
      // }
      if (!this.CheckGSTCNO(gst1Item.Number, "after")) {
        return false;
      }
    }
    const filteredData = this.registerarray.map(item => {
      item.IsNetworkCompany = true;
      const { FileNameObj, NumberObj, IsForLifeTimeObj, ValidityObj, ...filteredItem } = item;
      return filteredItem;
    });
    if (filteredData.length === 0) {
      console.log("No data to save:", filteredData);
      return;
    }
    this._appService.Post("Company", "SaveRegistration", filteredData).subscribe((response) => {
      this.toastr.success("Registration data saved Successfully !", "Success");
      this.GetRegister();
      this.onclose();
    },
    (err) => {
      this.toastr.error("Error occurred while saving Registration Data !", "error");
    });
  }

  authorizeTransaction(Id: any) {
    // if (!Id) {
      this._appService.GetByThreeId("Common", "AuthorizeTransaction", 6, Id, this.CompanyId).subscribe(
        (response) => {
          // this.onclose();
          // this.toastr.success("Network Authorized Successfully!", "Success");
          Helpers.setLoading(false);
        },
        (err) => {
          // this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        }
      );
    // }
  }

  onclose() {
    this.onCloseEvent.emit();
  }

  GetTransportServiceType() {
    this.networkService.getTransportServiceType().then(res => {
      this.NetworkType = { ...this.NetworkType, dropdownList: [...res] };
      const networkTypes = res.map((item: any) => item.NetworkType);
      console.log('this.typeOfService.NetworkType', networkTypes)
    }).catch(error => {

    })
  }

  GetNetworkSubTypeList() {
    this.networkService.getNetworkType().then(res => {
      this.NetworkSubType = { ...this.NetworkSubType, dropdownList: [...res] };
    }).catch(error => {

    })
  }

  GetDeliverPartnerList() {
    let obj = {
      Status: 'All',
      TenantId: this.TenantId
    };
    this.networkService.getDeliveryPartner(obj).then(res => {
      this.deliveryPartner = { ...this.deliveryPartner, dropdownList: [...res] };
    }).catch(error => {

    })
  }

  getAccountType(value: any, isScrollDown = false, exactMatch = false) {
    this.accountType.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.accountType.dropdownList.length / 20) + 1;
    }
    this.vehicleService.GetAccountListforNetwork(value, pageNo).then(res => {
      let dropdownList = [...res.Results];
      if (exactMatch && value) {
        dropdownList = dropdownList.filter(x =>
          x.name && x.name.trim().toLowerCase() === value.trim().toLowerCase()
        );
      }

      if (isScrollDown && res.Total > this.accountType.dropdownList.length) {
        dropdownList = dropdownList.concat(this.accountType.dropdownList);
        this.accountType = { ...this.accountType, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.accountType = { ...this.accountType, dropdownList: [...dropdownList] });
      this.accountType.isSearch = false;
    }).catch(error => {
      this.accountType.isSearch = false;
    })
  }

  getSalesperson(value: any, isScrollDown = false) {
    this.SalesPerson.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.SalesPerson.dropdownList.length / 20) + 1;
    }
    this.vehicleService.GetsalespersonforNetwork(value, pageNo).then(res => {
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.SalesPerson.dropdownList.length) {
        dropdownList = dropdownList.concat(this.SalesPerson.dropdownList);
        this.SalesPerson = { ...this.SalesPerson, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.SalesPerson = { ...this.SalesPerson, dropdownList: [...dropdownList] });
      this.SalesPerson.isSearch = false;
    }).catch(error => {
      this.SalesPerson.isSearch = false;
    })
  }

  GetDefaultNetworkAccountsType() {
    this._appService.Get("Network", "nt_GetDefaultNetworkAccountsType").subscribe((response) => {
      this.DefaultNetworkAccountsType = response;
    });
  }

  applyDefaultAccountType(defaultFlag: any) {
    const dataFeild = 'AccountTypeId';
    this.DefaultNetworkAccountsType.forEach((element: any) => {
      if (element[defaultFlag] === true) {
        if (element.Id != null) {
          this.accountType[dataFeild] = element.Id;
          this.data.AccountTypeId = element.Id;
          this.accountType.dropdownList = [];
          let obj: any = {};
          obj.value = element.Id;
          obj.name = element.Name;
          this.accountType.dropdownList.push(obj);
          // this.modifiedValueOutput.emit({ value: element.Id, dataFeild });
        } else {
          this.accountType[dataFeild] = null;
          // this.modifiedValueOutput.emit({ value: null, dataFeild });
        }
      }
    });
  }

  checkNetworkTypeCondition(selectedTransportIds: any) {
    const selectedNetworkTypes = this.NetworkType.dropdownList.filter((type: any) =>
      selectedTransportIds.includes(type.Id)
    );
    const isManufacturerSelected = selectedNetworkTypes.some((type: any) => type.NetworkType === 'Manufacturer');
    this.SalesPerson.isRequired = isManufacturerSelected;
    const isTransporterSelected = selectedNetworkTypes.some((type: any) => type.name === 'Road Freight');
    const isCustomerSelected = selectedNetworkTypes.some((type: any) => type.name === 'Customer');
    const isVendorSelected = selectedNetworkTypes.some((type: any) => type.name === 'Vendor');
    let accountTypeSet = false;
    if (isTransporterSelected) {
      this.applyDefaultAccountType('IsDefaultGroupForTransporter');
      accountTypeSet = true;
    }
    if (isCustomerSelected) {
      this.applyDefaultAccountType('IsDefaultGroupForCustomer');
      accountTypeSet = true;
    }
    if (isVendorSelected) {
      this.applyDefaultAccountType('IsDefaultGroupForVendor');
      accountTypeSet = true;
    }
    if (!accountTypeSet) {
      const dataFeild = 'AccountTypeId';
      this.accountType[dataFeild] = null;
      //this.modifiedValueOutput.emit({ value: null, dataFeild });
    }
  }

  getDropdownList(value: any, dataField: any, type: any) {
    if (dataField == 'SalesPerson') {
      if (value.length > 0) {
        type.isSearch = true;
        this._appService.GetById("AccountingReport", "GetSalesPerson", value).subscribe((response) => {
          this.findObjectOfTheField(dataField, response, type);
        },
          (err) => {
            this.toastr.error("Error occurred while fetching data!", "error");
          }
        );
      }
    }
  }

  getBroker(value: any, isScrollDown = false) {
    this.Broker.isSearch = true;
    let pageNo = 1;
    if (isScrollDown === true) {
      pageNo = Math.ceil(this.Broker.dropdownList.length / 20) + 1;
    }
    this._appService.GetByQueryPage("AccountingReport", "GetUserDropDown", value, pageNo).subscribe(res => {
      res.Results.map((x: any) => {
        x.name = x.text;
        x.value = x.id;
      })
      let dropdownList = [...res.Results];
      if (isScrollDown && res.Total > this.Broker.dropdownList.length) {
        dropdownList = dropdownList.concat(this.Broker.dropdownList);
        this.Broker = { ...this.Broker, dropdownList: [...dropdownList] };
      }
      !isScrollDown && (this.Broker = { ...this.Broker, dropdownList: [...dropdownList] });
      this.Broker.isSearch = false;
    }), ((error: any) => {
      this.Broker.isSearch = false;
    })
  }

  findObjectOfTheField(dataField: any, dropdownList: any, type: any) {
    type.dropdownList = dropdownList;
    type.isSearch = false;
    if (type.dataField) {
      type.isReadOnly = false
    }
  }

  setAddDropdownData(field: any, value: any, name: any) {
    field.dropdownList = [{ value, name }];
    this.Addressdata[field.dataField] = value;
  }

  GetShowListForSalesPersonBroker() {
    this._appService.GetById("Common", "GetSystemSettingByName", "ShowListForSalesPersonBroker").subscribe(
      (response) => {
        if (response == '1') {
          this.IsShowListForSalesPersonBroker = true;
        } else {
          this.IsShowListForSalesPersonBroker = false;
        }
      },
      (err) => {
        this.toastr.error("Error occurred while fetching Status data !", "error");
      }
    );
  }

  getAddressDetails(searchedKey: any) {
    this.isSearch = true;
    this.driverService.getAdressDetailByPostcode(searchedKey).then((x: any[]) => {
      x = x.slice(0, 50);
      this.postalCode = { ...this.postalCode, dropdownList: x };
      this.isSearch = false;
    }).catch((error) => {
      this.isSearch = false;
    })
  }

  getCountryDetails(searchedKey: any, categoryName: any, parentId: any = null, objName: any) {
    this[objName].isSearch = true;
    this.driverService.getCountryDetailByPostcodeV2(searchedKey, categoryName, parentId).then((x: any[]) => {
      x = x.slice(0, 50);
      this[objName] = { ...this[objName], dropdownList: x };
      this[objName].isSearch = false;
    }).catch((error) => {
      this[objName].isSearch = false;
    })
  }

  getCountryDetailsV2(searchedKey: any, categoryName: any, parentId: any = null, objName: any) {
    this.driverService.getCountryDetailByPostcodeV2(searchedKey, categoryName, parentId).then((x: any[]) => {
      x = x.slice(0, 50);
      this.country = { ...this.country, dropdownList: x };
      var data = this.country.dropdownList.find((x: any) => x.name === 'India');
      var obj: any = {};
      this.data.Country = data.value;
      obj.value = data.value;
      obj.name = data.name;
      this.country.dropdownList = [];
      this.country.dropdownList.push(obj);
    }).catch((error) => {
    })
  }

  // Added by priya - 16/04/2026 - cn(PRIYA-APR26-008)
  onTaxPreferenceChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    if (this.Taxdata == null)
      this.Taxdata = {};

    this.Taxdata.TaxPreference = inputElement.value;

    if (this.Taxdata.TaxPreference === 'TaxExempt') {
      this.TaxExemptionReason.isRequired = true;
      this.LUTBondNumber.isRequired = true;
      this.LUTBondStartDate.isRequired = true;
      this.LUTBondEndDate.isRequired = true;
    }
    this.getTaxChangedValue(this.Taxdata.TaxPreference, 'taxPreference');
  }

  changeReverseChangeMechnaism(status: any) {
    this.getTaxChangedValue(status, this.ReverseChangeMechnaism.dataField);
  }

  changeIsTDSdeductionrequired(status: any) {
    this.getTaxChangedValue(status, this.IsTDSdeductionrequired.dataField);
  }

  GetTaxExemptionReason() {
    return new Promise((resolve, reject) => {
      this._appService.Get("Company", "GetTaxExemptionReason").subscribe((response) => {
        if (response) {
          response.map((x: any) => {
            x.name = x.Label;
            x.value = x.Id;
          })
        }
        this.TaxExemptionReason = { ...this.TaxExemptionReason, dropdownList: response };
        if (this.Taxdata && !this.Taxdata.TaxExemptionId) {
          var reason = this.TaxExemptionReason.dropdownList.find((x: any) => x.name === 'Not Registered');
          if (reason) {
            this.Taxdata.TaxExemptionId = reason.value;
          }
        }
      },
        (err) => {
          this.toastr.error("ErrorfetchingReason", "error");
        }
      );
    });
  }

  GetExportType() {
    this._appService.GetById("Common", "GetLookByCategoryName", "Export Type").subscribe((response) => {
      if (response) {
        response.map((x: any) => {
          x.name = x.Label;
          x.value = x.Id;
        })
      }
      this.ExportType = { ...this.ExportType, dropdownList: response };
    },
      (err) => {
        this.toastr.error("ErrorfetchingReason", "error");
      }
    );
  }

  GetManageTds() {
    return new Promise((resolve, reject) => {
      this._appService.Get("Company", "GetTdsList").subscribe((response) => {
        if (response) {
          response.map((x: any) => {
            x.name = x.Label;
            x.value = x.Id;
          })
        }
        this.ManageTdsList = { ...this.ManageTdsList, dropdownList: response };
        if (this.Taxdata && !this.Taxdata.ManageTdsId) {
          var reason = this.ManageTdsList.dropdownList.find((x: any) => x.name === 'Not Applicable');
          if (reason) {
            this.Taxdata.ManageTdsId = reason.value;
          }
          this.ManageTdsList.isReadOnly = false;
        }
      },
        (err) => {
          this.toastr.error("ErrorfetchingReason", "error");
        }
      );
    });
  }

  // Added by priya - 17/04/2026 - cn(PRIYA-APR26-008)
  GetRegister() {
    this._appService.GetById("Network", "GetRegisteredDocss", this.networkId).subscribe(
      (res) => {
        if (res && Array.isArray(res) && res.length > 0) {
          this.registerarray = res.map((item) => {
            const fullFileName = item.FileName || "";
            const displayFileName = fullFileName.includes("_")
              ? fullFileName.split("_").pop()
              : fullFileName;
            const filepath = environment.apiUrl + item.DocumentPath;
            console.log("filepath", filepath);

            return {
              ...item,
              FileNameObj: {
                Label: "File Name",
                dataField: "FileName",
                formControlName: "FileName",
                documentpath: item.DocumentPath,
                filepath: filepath,
                filename: displayFileName,
              },
              NumberObj: {
                Label: "Number",
                dataField: "Number",
                formControlName: "Number",
                placeholder: "Enter number",
              },
              IsForLifeTimeObj: {
                lable: "Is Default",
                dataField: "IsForLifeTime",
              },
              ValidityObj: {
                placeholder: "Select date",
                dataField: "Validity",
                formControlName: "Validity",
                isReadOnly: this.isdatedisable,
              },
            };
          });
        } else {
          this.registerarray = [];
          if (this.registerarray.length == 0) {
            this.GetRegistrationData();
          }
        }
        console.log('Inside GetRegisteredDocss', this.registerarray);
      },
      (error) => {
        console.log("Error while Getting Register", error);
      }
    );
  }

  onFileSelectFn(event: any, data: any) {
    const selectedFile = event.target.files[0];
    const { formData, options } = this.commonService.setHeaderAndOptionsForFileUpload(selectedFile);
    const apiUrl =
      environment.apiUrl + "/api/Document/UploadAttachment?ReferenceId=" +
      this.networkId + "&TransectionType=" + data.Label + "&ParentId=" + null;
    const req1 = this.anghttp.post(apiUrl, formData, options).subscribe(
      (response) => {
        var uploadSuccess = this.translate.instant("Attachment.AttachmentUploadSuccess")
        this.toastr.success(
          uploadSuccess,
          "success"
        );
      },
      (err) => {
        var uploadError = this.translate.instant("Attachment.UploadError")
        this.toastr.error(uploadError, "error");
      }
    );
  }

  onFileDeleteFn(selectedFile: any) {
    // this.onFileDelete.emit(selectedFile);
  }

  getFilePreview(item: any) {
    if (item.documentpath && item.documentpath !== "." && item.filename) {
      const fullFileName = item.filepath || "";
      const displayFileName = fullFileName.includes("_")
        ? fullFileName.split("_").pop()
        : fullFileName;
      return [{ name: item.filename, url: item.filepath }];
    } else {
      return [];
    }
  }

  GetTaxPreference() {
    this._appService.GetById("Company", "GetTaxDataList", this.networkId).subscribe((response) => {
      this.ExportsType = response[0].TaxPreference;
      console.log("ExportType", this.ExportsType);
    },
      (error) => {
        console.log("Error while Getting Register", error);
      })
  }

  CheckGSTCNO(ctrl: any, ValidationPosition: any) {
    if (this.OtherDetails.TaxPreference == 'Taxable' && this.OtherDetails.ExemptionReasonText == 'SAMPLE') {
      return true;
    } else {
      const validGSTNO = 'Invalid GST No.';
      var regex = /^([0-9]){2}([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([a-zA-Z]){1}([0-9a-zA-Z]){1}?$/;
      if (regex.test(ctrl) == true || ctrl == undefined) {
        return true;
      }
      else {
        this.toastr.error("GST1 (15 digit) number is Invalid!", "Error");
        return false;
      }
    }
  }

  GetRegistrationData() {
    if (this.country != null) {
      this._appService.GetByTwoId("Common", "GetLookByCategoryNameAndParent", "RegistrationDocuments", this.Addressdata.Country).subscribe(
        (response) => {
          if (response && Array.isArray(response) && response.length > 0) {
            this.registerarray = response.map((item) => {
              const fullFileName = item.FileName || "";
              const displayFileName = fullFileName.includes("_")
                ? fullFileName.split("_").pop()
                : fullFileName;
              const filepath = environment.apiUrl + item.DocumentPath;
              console.log("filepath", filepath);
              return {
                ...item,
                DocumentId: item.Id,
                CompanyId: this.networkId,
                FileNameObj: {
                  Label: "File Name",
                  dataField: "FileName",
                  formControlName: "FileName",
                  documentpath: item.DocumentPath,
                  filepath: filepath,
                  filename: displayFileName,
                },
                NumberObj: {
                  Label: "Number",
                  dataField: "Number",
                  formControlName: "Number",
                  placeholder: "Enter number",
                },
                IsForLifeTimeObj: {
                  lable: "Is Default",
                  dataField: "IsForLifeTime",
                },
                ValidityObj: {
                  // lable: "Date",
                  placeholder: "Select date",
                  dataField: "Validity",
                  formControlName: "Validity",
                  isReadOnly: this.isdatedisable,
                },
              };
            });
          }
          console.log('inside GetLookByCategoryNameAndParent', this.registerarray);
        },
        (err) => {
          this.toastr.error("Error occurred while getting registration data !", "error");
        }
      );
    }
  }

}
